import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@px/px_design_system";

const WithFeatureStatus = ({
  statusText,
  statusColor,
  badgeClassName,
  expirationDate,
  text,
}) => {
  return (
    <div className="feature--warning">
      <span className="feature--warning__text">{text}</span>
      {new Date(expirationDate) > new Date() ? (
        <Badge className={`${badgeClassName}`} color={statusColor} pill>
          {statusText}
        </Badge>
      ) : null}
    </div>
  );
};

export default WithFeatureStatus;

WithFeatureStatus.defaultProps = {
  statusText: "Coming Soon",
  statusColor: "warning",
  badgeClassName: "",
  expirationDate: "",
  text: "",
};

WithFeatureStatus.propTypes = {
  statusText: PropTypes.string,
  statusColor: PropTypes.string,
  badgeClassName: PropTypes.string,
  expirationDate: PropTypes.string,
  text: PropTypes.string,
};
